import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";
import { Link, NavLink, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { Dash1, Dash2, Dash3, Dash4 } from "../../../common/imagePath";
import CountUp from "react-countup";
import moment from "moment";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { checkUserPermission } from "../../../common/UserPermission";
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { toastSuccess } from "../../../common/Toast";
import { generateFinalKey } from "../../../common/common";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";

const EcomOrders = (props) => {
  let selectData = [];
  let PERMISSION_DELETE = "sales-batch-delete";
  let PERMISSION_EDIT = "/manage-sales/:id";
  let PERMISSION_ADD = "/manage-sales";
  let PERMISSION_RECEIVEPAYMENT = "/receive-payment";
  let PERMISSION_RECEIPT = "/sales-receipt/:id";
  let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
  let PERMISSION_DELIVERIES = "/deliveries";
  let PERMISSION_BATCHSALES = "/batch-sales";
  let PERMISSION_CUSTOMFIELD = "/custom-field-sales-configuration";
  let PERMISSION_ALLRECEIPT = "/sales-all-receipt";

  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [quickbookarray, setquickbookarray] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const[customerid , setcustomerid] = useState(0);
  const [data, setData] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [salesSummary, setSalesSummary] = useState([]);
  const [status, setStatus] = useState(0);
  const [isShowEcomOrders, setIsShowEcomOrders] = useState(3);

  const options = [
    { label: "All", value: 1 },
    { label: "Custom", value: 2 },
    { label: "Last Week", value: 3 },
    { label: "Current Week", value: 4 },
    { label: "Last Month", value: 5 },
    { label: "Current Month", value: 6 },
  ];

  const ishowEcomOptions = [
    { label: "All", value: 1 },
    { label: "Portal Order", value: 2 },
    { label: "Ecom Order", value: 3 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "Current Month",
    value: 6,
  });

  console.log(isShowEcomOrders, "isShowEcomOrders");
  console.log(data, "datalist316");

  const [startingDate, setStartingDate] = useState(moment().format("YYYY-MM-DD"));
  const [endingDate, setEndingDate] = useState("");
  console.log(startingDate,"888");
  

  const [customStartingDate, setCustomStartingDate] = useState(moment().format("YYYY-MM-DD"));
  const [ecomOrderApproveID, setEcomOrderApproveID] = useState(0);
  const [customEndingDate, setCustomEndingDate] = useState(moment().format("YYYY-MM-DD"));

  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [customerValue, setCustomerValue] = useState();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  const approveRejectEcomSales = (ID, type) => {
    console.log("ecom sales data ==> 4785", ID);
    setEcomOrderApproveID(ID);

    const approverejectobj = {
      status: type === "Approve" ? 1 : 2,
      id: ID,
      loginuserid: loginuserid ? loginuserid : 0,
      locationId: location ? location : 0,
      Customerquickbookid:customerid,
    };

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/ecommorderapprovereject`,
        approverejectobj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then(() => {
        toastSuccess(`${type} Ecom Order SuccessFully`);
        handleListData(
          startingDate,
          endingDate,
          salesTypeID,
          customerID,
          globalFilter,
          pagination,
          sorting,
          status,
          columnFilters,
          isShowEcomOrders
        );
        // window.location.reload()
      });
  };

  console.log(ecomOrderApproveID, "ecomOrderApproveID 4785");

  // const handleChangeCustomStartingDate = (event) => {
  //   console.log("event starting ==> ", event.target.value);
  //   setCustomStartingDate(event.target.value);
  //   setStartingDate(event.target.value);
  // };

  const handleChangeCustomStartingDate = (selectedDate) => {
    console.log(selectedDate,"888");
    
    setStartingDate(selectedDate);
    setCustomStartingDate(selectedDate);
    // if (selectedDate ) {
    //   const datetime =
    //     moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
    //   const settime = moment(datetime).format("YYYY-MM-DD");
    //   console.log(settime, "settime");
    // }
  };


  // const handleChangeCustomEndingDate = (event) => {
  //   // console.log("event ending ==> ", event.target.value);
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };

  const handleChangeCustomEndingDate = (selectedDate) => {
    
      setCustomEndingDate(selectedDate);
      setEndingDate(selectedDate);
    
  };

  console.log("QuickBookOptions::>>", quickBookOptions);
  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status,
      columnFilters,
      isShowEcomOrders
    );
  };

  const handleUnSuspend = (pID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/findbyid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = (
    // pagenumber,
    // pagesize,
    // filtertext,
    // ordercolumn,
    // currentorder,
    startingdate,
    endingdate,
    salestypeid,
    customerid,
    globalFilter,
    pagination,
    sorting,
    status,
    columnFilters,
    isShowEcomOrders
  ) => {
    setLoading(true);

    salestypeid = salestypeid > 0 ? salestypeid : 0;
    customerid = customerid > 0 ? customerid : 0;
    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    const FilterColumnText = {};
    // FilterColumnText.filtercolumntext = columnFilters;
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/ecomordersaleslist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&status=${status}&enddate=${endingdate}&salestypeid=${salestypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
          "Location"
        )}&isShowEcomOrders=${isShowEcomOrders}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  // const handleDeletePopup = (pID) => {
  //   const deleteRequestParam = {
  //     saleids: pID || selectedSalesCheckboxIds,
  //     locationid: location,
  //     loginuserid: loginuserid,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (saletypeid, id, qbid, rows, field) => {
    console.log(id, "id=====>");
    let ids;
    let rowdata = [];

    if (field == "multipleRowInactive") {
      console.log("checkes");
      ids = rows.map((el) => el.original.ID).join(",");
      rowdata = rows.map((el) => {
        return {
          quickbookid: el.original.QuickBookId,
          type: el.original.SaleTypeId,
        };
      });
      // setquickbookarray(rowdata);
      console.log(rowdata, "rowdata====>");
    } else {
      ids = id;
      const obj = {
        quickbookid: qbid,
        type: saletypeid,
      };
      rowdata.push(obj);
    }

    const deleteRequestParam = {
      quickbookarray: rowdata,
      saleids: ids,
      locationid: location,
      loginuserid: loginuserid,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };
  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      // 1,
      // perPageSize,
      // searchtext,
      // sortingId,
      // sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status,
      columnFilters,
      isShowEcomOrders
    );
    // }
  }, [
    salesTypeID,
    customerID,
    status,
    quickBookOptions,
    globalFilter,
    pagination,
    sorting,
    columnFilters,
    isShowEcomOrders,
  ]);

  const statusoption = [
    { label: "Approved", value: 1 },
    { label: "Pending", value: 0 },
    { label: "Rejected", value: 2 },
  ];

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           <Link className="btn btn-primary btn-sm btn-custom-padding"
  //             to={`/manage-sales/${row.ID}`}
  //             style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //           >
  //             Edit
  //           </Link>

  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">

  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ID)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>&nbsp;Delete Sales
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 to={`/sales-receipt/${row.ID}`}
  //                 className="dropdown-item me-3"
  //               >
  //                 <i className="fa fa-file" aria-hidden="true"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //             {
  //               row.Receipt && (
  //                 <li>
  //                   <Link
  //                     // className="btn btn-sm btn-outline-primary btn-custom-padding"
  //                     className="dropdown-item me-3"
  //                     target="_blank"
  //                     to={row.Receipt}
  //                   >
  //                     <i className="fa fa-paperclip"></i>Attachment
  //                   </Link>
  //                 </li>
  //               )
  //             }
  //           </div>
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,

  //   },

  //   {
  //     // name: "Sale /\r\n Estimate /\r\n Return No",
  //     name: "Invoice No",
  //     selector: row => row["InvoiceNo"],
  //     sortable: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Date",
  //     //selector: "Saletime",
  //     selector: (row) => formatDate(row.Saletime),
  //     // selector: (row) => moment(row.Saletime).format("YYYY-MM-DD"),
  //     sortable: true,
  //     width: "110px",
  //   },
  //   {
  //     name: "Type",
  //     selector: row => row["SalesType"],
  //     sortable: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Status",
  //     selector: "StatusName",
  //     sortable: true,
  //     width: "100px"
  //   },
  //   {
  //     name: "Customer",
  //     cell: (row) => (
  //       <>
  //         <Link className="text-warning word-break-data" to={`/manage-customers/${row.Customerid}`}>
  //           {row.CustomerName}
  //         </Link>
  //       </>
  //     ),
  //     sortable: true,
  //     width: "150px",
  //   },

  //   {
  //     name: "Total",
  //     selector: row => row["Total"] > 0 ? parseFloat(row["Total"]).toFixed(2) : 0,
  //     right: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Amount Paid",
  //     selector: row => row["Paymentamount"] > 0 ? parseFloat(row["Paymentamount"]).toFixed(2) : 0,
  //     // sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   {
  //     name: "Wallet Applied",
  //     selector: row => row["CreditApplied"] > 0 ? parseFloat(row["CreditApplied"]).toFixed(2) : 0,
  //     // sortable: true,
  //     right: true,
  //     width: "150px",
  //   },

  //   {
  //     name: "Amount Due",
  //     // selector: row => row[field]"AmountDue",
  //     right: true,
  //     width: "150px",
  //     cell: (row) =>
  //       row.SaleTypeId == 1 ? row.AmountDue > 0 ? parseFloat(row.AmountDue).toFixed(2) : 0 : "-",
  //   },

  //   {
  //     name: "Location",
  //     selector: row => row["Location"],
  //     // width: "150px",
  //     // sortable: true,
  //   },
  //   {
  //     name: "Due Date",
  //     selector: (row) => row.DueDate != undefined && row.DueDate != "0000-00-00" ? formatDate(row.DueDate) : "",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Aging",
  //     // selector: row => row["Aging"],
  //     sortable: false,
  //     width: "70px",
  //     cell: (row) => (row.Aging > 0 ? row.Aging : ""),
  //   }

  // ];

  const columns = useMemo(() => [
    {
      header: "Sale ID",
      accessorKey: "ID",
      size:120,
    },
    {
      //     //       {checkUserPermission(PERMISSION_EDIT) && (
      //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
      //     //           to={`/manage-customers/${row.Id}`}
      //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      //     //         >
      //     //           Edit
      //     //         </Link>
      //     //       )}
      //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
      //     //         <>
      //     //           <button
      //     //             type="button"
      //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
      //     //             data-bs-toggle="dropdown"
      //     //             aria-haspopup="true"
      //     //             aria-expanded="false"
      //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      //     //           >
      //     //           </button>
      //     //           <div className="dropdown-menu">
      //     //             {checkUserPermission(PERMISSION_EDIT) ? (
      //     //               <li>
      //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
      //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //             {checkUserPermission(PERMISSION_DELETE) ? (
      //     //               <li>
      //     //                 <Link
      //     //                   className="dropdown-item confirm-text"
      //     //                   to="#"
      //     //                   title="Delete"
      //     //                   data-bs-toggle="modal"
      //     //                   data-bs-target="#DeleteConfirmationModal"
      //     //                   onClick={() => handleDeletePopup(row.Id)}
      //     //                 >
      //     //                   <i
      //     //                     className="fa fa-trash"
      //     //                     data-bs-toggle="tooltip"
      //     //                     title="Delete"
      //     //                   ></i>
      //     //                   Delete
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //           </div>
      //     //         </>
      //     //       )}
      //     //     </div>
      //     //   ),
      //     //   ignoreRowClick: true,
      //     //   allowOverflow: true,
      //     //   button: true,
      //     //   //width: "7%",//"100px",
      //     //   minWidth: "90px",
      //     //   width: "90px",
      //     // },
      //     // {
      //     //   name: "Company Name",
      //     //   selector: "CompanyName",
      //     //   sortable: true,
      //     //   width: "170px",
      //     //   cell: (row) => (

      //     //     <>
      //     //       {checkUserPermission(PERMISSION_EDIT) ?
      //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //     //           {row.CompanyName}
      //     //         </Link>
      //     //         :
      //     //         row.CompanyName
      //     //       }
      //        header: "Company Name",
      //       accessorKey: "CompanyName",
      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     {
      //       header: "Name",
      //       accessorKey: "Name",
      //       Cell: ({ row }) => (
      //         <>
      //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //             {row.original.FirstName} {row.original.LastName}
      //           </Link>
      //         </>
      //       ),

      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     // {
      //     //   header: "DATE",
      //     //   accessorKey: "DATE",
      //     //   Cell: ({row})=> moment(row.original.DATE).format('YYYY-MM-DD')
      //     // },
      //     {
      //       header: "E-Mail",
      //       accessorKey: "Email",
      //       Cell: ({ row }) => (
      //         <>
      //           <p title={row.original.Email}>{row.original.Email}</p>
      //         </>
      //       ),
      // =======
      header: "Invoice Referance No",
      accessorKey: "InvoiceReferanceNo",
      size:120,
      Cell: ({ row }) => (
        <Link 
        to={`/ecompendingincoice?i=${generateFinalKey(row.original.ID)}`} target="_blank" rel="noreferrer"
        > 
        <Box
          component="span"
          target="_blank" 
          rel="noreferrer"
          sx={(theme) => ({
            backgroundColor: "var(--primary-color-50)",
            borderRadius: "0.3rem",
            color: "#000",
            maxWidth: "9ch",
            p: "0.3rem",
            cursor: "pointer",
          })}
          >
          {row.original.InvoiceReferanceNo}
        </Box>
          </Link>
      ),
    },
    {
      header: "Ecom Status",
      accessorKey: "ApprovalStatus",
      Cell: ({ row }) =>
        row.original.ApprovalStatus == 1 ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            Approved
          </Box>
        ) : row.original.ApprovalStatus == 0 ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            Pending
          </Box>
        ) : (
          <Box
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#FBECF0',
              borderRadius: "0.3rem",
              color: "#E5AAB7",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            Rejected
          </Box>
        )
    },
    {
      header: "Date",
      accessorKey: "Saletime",
      size:140,
      Cell: ({ row }) =>
        moment(row.original.Saletime).format("MM-DD-YYYY"),
    },
    // {
    //   header: "Type",
    //   accessorKey: "SalesType",
    //   size:120,
    // },
   
    // {
    //   header: "Status",
    //   accessorKey: "StatusName",
    //   size:120,
    //   Cell: ({ row }) =>
    //     row.original.StatusName == "Paid" ? (
    //       <Box
    //         // class="text-warning word-break-data"
    //         // to={`/manage-suppliers/${row.original.SupplierId}`}
    //         component="span"
    //         sx={(theme) => ({
    //           // backgroundColor: '#E8F7F5',
    //           borderRadius: "0.3rem",
    //           color: "var(--success-main-color)",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.StatusName}
    //       </Box>
    //     ) : row.original.StatusName == "Completed" ? (
    //       <Box
    //         component="span"
    //         sx={(theme) => ({
    //           // backgroundColor: 'var(--primary-color-50)',
    //           borderRadius: "0.3rem",
    //           color: "var(--neutral-main-color)",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.StatusName}
    //       </Box>
    //     ) : row.original.StatusName == "Pending" ? (
    //       <Box
    //         component="span"
    //         sx={(theme) => ({
    //           //  backgroundColor: '#FEF7E2',
    //           borderRadius: "0.3rem",
    //           color: "var(--error-main-color)",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.StatusName}
    //       </Box>
    //     ) : row.original.StatusName == "Rejected" ? (
    //       <Box
    //         component="span"
    //         sx={(theme) => ({
    //           // backgroundColor: '#FBECF0',
    //           borderRadius: "0.3rem",
    //           color: "#E5AAB7",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.StatusName}
    //       </Box>
    //     ) : (
    //       ""
    //     ),
    // },
    {
      header: "Customer",
      accessorKey: "CustomerName",
      Cell: ({ row }) => (
        // <>
        //   <Link

        //     className="text-warning word-break-data"
        //     to={`/manage-customers/${row.original.Customerid}`}
        //   >
        //     {row.original.CustomerName}
        //   </Link>
        // </>

        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight:"700",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            navigate(`/manage-customers/${row.original.Customerid}`)
          }
        >
          {row.original.CustomerName}
        </Box>
      ),
    },
    {
      header: "Total",
      accessorKey: "Total",
      size:120,
      Cell: ({ row }) =>
        row.original.Total > 0 ? parseFloat(row.original.Total).toFixed(2) : 0,
    },
    {
      header: "Order Type",
      accessorKey: "orderType",
      size:120,
      // Cell: ({ row }) =>
      //   row.original.Total > 0 ? parseFloat(row.original.Total).toFixed(2) : 0,
    },
    // {
    //   header: "Amount Paid",
    //   accessorKey: "Paymentamount",
    //   Cell: ({ row }) =>
    //     row.original.Paymentamount > 0
    //       ? parseFloat(row.original.Paymentamount).toFixed(2)
    //       : 0,
    // },
    // {
    //   header: "Wallet Applied",
    //   accessorKey: "CreditApplied",
    //   Cell: ({ row }) =>
    //     row.original.CreditApplied > 0
    //       ? parseFloat(row.original.CreditApplied).toFixed(2)
    //       : 0,
    // },
    // {
    //   header: "Amount Due",
    //   accessorKey: "AmountDue",
    //   Cell: ({ row }) =>
    //     row.original.SaleTypeId == 1
    //       ? row.original.AmountDue > 0
    //         ? parseFloat(row.original.AmountDue).toFixed(2)
    //         : 0
    //       : "-",
    // },
    // {
    //   header: "Location",
    //   accessorKey: "Location",
    //   // Cell: ({ row }) => row.original.SaleTypeId == 1 ? row.original.AmountDue > 0 ? parseFloat(row.original.AmountDue).toFixed(2) : 0 : "-",
    // },
    // {
    //   header: "Due Date",
    //   accessorKey: "DueDate",
    //   Cell: ({ row }) =>
    //     row.original.DueDate != undefined &&
    //     row.original.DueDate != "0000-00-00"
    //       ? formatDate(row.original.DueDate)
    //       : "",
    // },
    // {
    //   header: "Aging",
    //   accessorKey: "Aging",
    //   Cell: ({ row }) => (row.original > 0 ? row.original : ""),
    // },
    // {
    //   header: "Ecom Orders",
    //   accessorKey: "isEcommerce",
    //   Cell: ({ row }) => (
    //     <Box
    //       component="span"
    //       sx={(theme) => ({
    //         borderRadius: "0.3rem",
    //         maxWidth: "9ch",
    //         p: "0.3rem",
    //         fontWeight: "bold",
    //         // color: row.original.isEcommerce > 0 ? "var(--success-main-color)" : "var(--error-main-color)",
    //       })}
    //     >
    //       {row.original.isEcommerce > 0 ? "Ecommerce Order" : "Portal"}
    //     </Box>
    //   ),
    // },
    // {
    //   header : "SyncStatus",
    //   accessorKey : "SyncStatus"
    // },
    // {
    //   header: "Quickbooks Sync Status",
    //   accessorKey: "SyncStatusName",

    //   Cell: ({ row }) =>
    //     row.original.SyncStatusName == "Completed" ? (
    //       <Box
    //         // class="text-warning word-break-data"
    //         // to={`/manage-suppliers/${row.original.SupplierId}`}
    //         component="span"
    //         sx={(theme) => ({
    //           // backgroundColor: '#E8F7F5',
    //           borderRadius: "0.3rem",
    //           color: "var(--success-main-color)",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.SyncStatusName}
    //       </Box>
    //     ) : row.original.SyncStatusName == "Failed" ? (
    //       <Box
    //         component="span"
    //         sx={(theme) => ({
    //           //  backgroundColor: '#FEF7E2',
    //           borderRadius: "0.3rem",
    //           color: "var(--error-main-color)",
    //           maxWidth: "9ch",
    //           p: "0.3rem",
    //           fontWeight: "bold",
    //         })}
    //       >
    //         {row.original.SyncStatusName}
    //       </Box>
    //     ) : (
    //       ""
    //     ),
    //   // enableGrouping: false, //do not let this column be grouped
    // },
    // {
    //   header: "Profile",
    //   accessorKey: "Image",
    //   Cell: ({ row }) => (
    //     <>
    //       <a href={row.original.Image} target="_blank">
    //         <img
    //           src={row.original.Image}
    //           alt="Profile Image"
    //           style={{
    //             maxWidth: "30px",
    //             maxHeight: "70px",
    //             margin: "5px",
    //           }}
    //           onError={(e) => {
    //             e.target.onerror = null;
    //             e.target.src = Noimage;
    //           }}
    //         ></img>
    //       </a>
    //     </>
    //   ),
    // },
    // {
    //   header: "Created On",
    //   accessorKey: "CreatedDate",
    //   Cell: ({ row }) => formatDate(row.original.CreatedDate),
    // },
  ]);

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };
  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const handleChangeCustomer = (event) => {
    setCustomerValue(event);
    setCustomerID(event?.value);
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });

    // top adtimation
    // axios
    //   .get(
    //     `${
    //       config.salesconfigBaseUrl
    //     }/sales/salessummary?locationid=${localStorage.getItem("Location")}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     setSalesSummary(response.data.ResponseData[0]);
    //     console.log(response.data.ResponseData, "==> setSalesSummary");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Sales</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Ecom Orders List</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 ">
              <div className="d-flex flex-wrap">
                <div className="col-md-2 mt-1">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="ml-2 col-md-2">
                      Custom Start Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}
                       <CommonDatePicker
                            FinalDate={customStartingDate}
                            handleDateChange={
                              handleChangeCustomStartingDate}
                           // disabled={!checkUserPermission("enable-for-employee")}
                          />
                    </div>
                    <div className="ml-2 col-md-2">
                      Custom End Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}
                      <CommonDatePicker
                            FinalDate={customEndingDate}
                            handleDateChange={handleChangeCustomEndingDate}
                           // disabled={!checkUserPermission("enable-for-employee")}
                          />
                    </div>
                  </>
                )}
                {quickBookOptions?.value == 2 && (
                  <div className="ml-2 col-md-1">
                    <button
                      className="btn btn-dark btn-sm mt-4 w-100"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      Search
                    </button>
                  </div>
                )}
                <div className="ml-2 col-md-2">
                  Sales Type:
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
                <div
                  className={
                    quickBookOptions?.value == 2
                      ? "ml-2 mb-2 col-md-2 "
                      : "ml-2 mb-2 col-md-4 "
                  }
                >
                  Customer:
                  <Select
                    defaultValue={customerValue}
                    onChange={(event) => {
                      handleChangeCustomer(event);
                    }}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>

                <div
                  className={
                    quickBookOptions?.value == 2
                      ? " mb-2 col-md-2 "
                      : "ml-2 mb-2 col-md-2 "
                  }
                >
                  Status:
                  <Select
                    defaultValue={status}
                    onChange={(e) => {
                      setStatus(e?.value);
                    }}
                    options={statusoption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
                {/* <div >

                  <input type="toggel" />
                    Show Ecom Order
                  </div> */}
                {/* <div
                  // class="form-check form-switch ml-3"
                  // style={{ alignSelf: "center", fontSize: "small" }}
                  className={
                    quickBookOptions?.value == 2
                      ? "mb-2 col-md-2"
                      : "ml-2"
                  }
                >
                  Show Ecom Order:
                  <Select
                    defaultValue={ishowEcomOptions?.find(el=> el.value ===isShowEcomOrders)}
                    onChange={(e) => {
                      setIsShowEcomOrders(e?.value);
                    }}
                    options={ishowEcomOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div> */}
              </div>
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body custom-table-css">
            <div className="table-responsive" style={{position:"relative", zIndex:'0'}}>
                {/* <DataTable
                  title="Sales List"
                  // columns={columns}
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  dense
                  paginationPerPage={perPageSize}
                /> */}
             
              <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  // enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  positionGlobalFilter="left"
                  renderRowActionMenuItems={({ row, closeMenu }) => [
                    row.original.ApprovalStatus == 0 && (
                      <MenuItem
                        key="edit"
                        onClick={() => {
                          approveRejectEcomSales(row.original.ID, "Approve");
                          //console.log(row.original ,"787584");
                          
                          setcustomerid(row.original.Customerquickbookid)
                          closeMenu();
                        }}
                      >
                        Approve
                      </MenuItem>
                    ),
                    row.original.ApprovalStatus == 0 && (
                      <MenuItem
                        key="edit"
                        onClick={() => {
                          approveRejectEcomSales(row.original.ID, "Reject");
                          closeMenu();
                        }}
                      >
                        Reject
                      </MenuItem>
                    ),
                  ]}
                  // renderTopToolbarCustomActions={({ table }) => (
                  //   <Box
                  //     sx={{
                  //       display: "flex",
                  //       gap: "1rem",
                  //       p: "0.5rem",
                  //       flexWrap: "wrap",
                  //     }}
                  //   >
                  //     {console.log(table, "tables")}

                  //     {(table.getIsSomeRowsSelected() ||
                  //       table.getIsAllRowsSelected()) &&
                  //     checkUserPermission(PERMISSION_DELETE) ? (
                  //       <Button
                  //         class="btn btn-sm btn-secondary"
                  //         style={{ display: "flex" }}
                  //         // size="small"
                  //         // disabled={
                  //         //   !table.getIsSomeRowsSelected() &&
                  //         //   !table.getIsAllRowsSelected()
                  //         // }
                  //         onClick={() =>
                  //           handleDeletePopup(
                  //             "",
                  //             "",
                  //             "",
                  //             table.getSelectedRowModel().rows,
                  //             "multipleRowInactive"
                  //           )
                  //         }
                  //         startIcon={<DeleteIcon />}
                  //         variant="contained"
                  //       >
                  //         Delete
                  //       </Button>
                  //     ) : (
                  //       ""
                  //     )}
                  //     {/* <Button
                  //       size="small"
                  //       onClick={() =>
                  //         setPagination({ ...pagination, pageSize: totalRows })
                  //       }
                  //       variant="contained"
                  //     >
                  //       Get All Data
                  //     </Button> */}
                  //   </Box>
                  // )}
                  rowVirtualizerOptions={{
                    overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                    estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "comfortable",
                    showGlobalFilter: true,
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  //For color of each alternative row(Zebra-column)
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300],
                  }}
                  // For providing color to header of table
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  manualFiltering
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined
                    {
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }
                  }
                  muiSelectCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiSelectAllCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
          
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/ecommorderapprovereject`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      <LookupReceiptSaleModal />
    </>
  );
};

export default EcomOrders;


